import EnquiryForm from "@/components/sections/EnquiryForm";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <SEO {...SEO_MAP.contact} />
      <PageHeader
        overline="Contact"
        title={<>Tell us about<br /><em className="italic text-gradient">your project</em>.</>}
        lead="Instead of pricing pages we scope every project individually. Share your brief — we'll come back within 24 hours."
      />
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pb-24">
        <EnquiryForm />
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-[13.5px]">
          <ContactBlock label="Email" value="hello@lanexlabs.com" />
          <ContactBlock label="Studio" value="London, United Kingdom" />
          <ContactBlock label="Hours" value="Mon–Fri · 09:00–18:00 GMT" />
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 text-[14px] text-[color:var(--text-muted)] leading-relaxed">
          <div>
            <h2 className="font-serif text-2xl text-[color:var(--text)] mb-3 tracking-tight">What happens next</h2>
            <p>
              Once you submit the brief, a senior member of our team reviews it personally — not a bot,
              not a junior sales rep. Within 24 business hours you'll receive a written response covering
              our initial read on scope, the questions we'd want to explore in a discovery call, an
              indicative delivery window, and a shaped budget range so you can decide whether it's worth
              a deeper conversation. If we're not the right fit for what you need, we'll say so clearly
              and, where we can, recommend a partner who is.
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-[color:var(--text)] mb-3 tracking-tight">Prefer to skip the form?</h2>
            <p>
              Email us directly at <strong>hello@lanexlabs.com</strong> with a short paragraph about your
              business, what you're trying to build and any constraints (timeline, budget, existing stack).
              For urgent requests use the WhatsApp button — a real human replies during working hours. For
              existing clients, use the messaging channel inside your client portal so context stays with
              your project. We treat every enquiry as confidential; NDAs are available on request before
              scoping discussions begin.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
function ContactBlock({ label, value }) {
  return (
    <div className="p-6 rounded-2xl border border-[color:var(--border)]">
      <div className="overline mb-2">{label}</div>
      <div className="font-serif text-2xl tracking-tight">{value}</div>
    </div>
  );
}
